import { Tooltip } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaEdit, FaPlus } from "react-icons/fa";
import SalesDashboard from "../SalesDirectory/SalesDashboard";
import ic_no_data from "../../utils/ic_no_data_to_show.svg";
import ic_timeline_circle_indicator from "../../utils/ic_timeline_icon.svg";
import axios from "axios";
import { format, set } from "date-fns";

const LogisticTask = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [tableRows, setTableRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [taskTimeLineList, setTaskTimeLineList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const paginate = (pageNumber) => {
    if (pageNumber >= 1) setCurrentPage(pageNumber);
  };
  const receiptsPerPage = 10;
  const totalPages = Math.ceil(filteredRows.length / receiptsPerPage);

  useEffect(() => {
    fetchLogisticsTaskList();
    fetchTaskTimeline();
  }, []);

  const fetchLogisticsTaskList = async (page = 1, search) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let apiURL = "";

    // if (customerType === "Supplier") {
    //   apiURL = `${
    //     apiPaths[0]?.API_CONFIG
    //   }/api/CRMAccountListPage/${COMPANY_CODE}/ACCOUNTLIST/MAIN/SUPPLIERS/-/${
    //     search || "-"
    //   }/${page}/${limit}`;
    // } else {
    //   apiURL = `${
    //     apiPaths[0]?.API_CONFIG
    //   }/api/CRMAccountListPage/${COMPANY_CODE}/ACCOUNTLIST/MAIN/CUSTOMERS/-/${
    //     search || "-"
    //   }/${page}/${limit}`;
    // }

    // apiURL = `https://cubixweberp.com:213/api/CRMLogisticTaskList/SUNRISEWEB/LIST/MAIN/-/2025-01-01/2026-12-30/1/20`;
    apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMLogisticTaskList/${companyCode}/LIST/${department}/-/2025-01-01/2026-12-30/1/20`;

    try {
      const response = await axios.get(apiURL);
      setTableRows(response.data || []);
      setFilteredRows(response.data || []); // ✅ Set filtered rows initially
    } catch (err) {
      console.error("Error while fetchDocumentTableCustomer", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTaskTimeline = async (voucherNo) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskHistoryList/${companyCode}/LOGITIMELINE/${department}/1001`;

    try {
      const response = await axios.get(url);
      console.log("Timeline Data:", response.data);
      setTaskTimeLineList(response.data || []);
    } catch (err) {
      console.error("Error while loading Task Timeline :", err);
    }
  };

  

  return (
    <div className="mx-2">
      <div className="flex flex-wrap items-center justify-between gap-16 mt-2">
        <div className="flex justify-end items-center">
          <input
            type="text"
            placeholder="Search Item"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-[300px]  px-3 py-2 shadow-sm text-sm rounded-md bg-white border border-gray-300 placeholder-gray-400 focus:outline-none focus:border-gray-400"
          />
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4 max-h-[60vh]">
        <table className="min-w-full bg-white border border-gray-200 text-sm shadow-sm">
          <thead className="bg-gray-100 text-sm sticky top-0 z-20 shadow-sm">
            <tr>
              {[
                "Time",
                "Task ID",
                "Branch",
                "Creator",
                "Task Type",
                "SKU",
                "Asignee",
                "Mode",
                "From",
                "To",
                "Area-Area",
                "PDD & Time",
                "Time",
                "Status",
                "Accepted & Initiated",
                "Recieved",
              ].map((header) => (
                <th
                  key={header}
                  className="px-4 py-1 font-semibold text-gray-700 border text-left"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredRows.length > 0 ? (
              filteredRows.map((rec, index) => (
                <tr
                  key={index}
                  className={`hover:bg-blue-50 border ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-4 w-30 py-2 border text-xs text-left">
                    {rec.Time}
                  </td>
                  <td className="px-4 py-2 w-54  border text-[0.78em] text-left">
                    {rec.task_id || "-"}
                  </td>
                  <td className="px-4  w-36  py-2 border text-xs text-left">
                    {rec.Branch || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.Creator || "-"}
                  </td>
                  <td className="px-4 py-2 w-36  border text-[0.78em] text-left">
                    {rec["Task Type"] || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.SKU}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.Assignee}
                  </td>
                  <td className="px-4 py-2 w-36  border text-xs text-left">
                    {rec.Mode || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.From || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.To || "-"}
                  </td>
                  <td className="px-4 py-2  w-28  border text-xs text-center">
                    {rec["Area-Area"] || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec["PDD &Time"] || "-"}
                  </td>
                  <td className="px-4 py-2  w-28  border text-xs text-right">
                    {rec["Time Passed"] || "-"}
                  </td>
                  <td className="px-4 py-2  w-28  border text-xs">
                    {rec.Status || "-"}
                  </td>
                  <td className="px-4 py-2  w-28  border text-xs">
                    {rec["Accepted & Initiated"] || "-"}
                  </td>
                  <td className="px-2 py-1 border-b text-xs text-gray-600 ">
                    {rec["Received From/Handed To"] || "-"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center py-6 text-gray-500">
                  {isLoading ? "Loading Data..." : "No Matching Records Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-between bg-gray-100 items-center px-2 py-4 shadow-sm rounded-md mt-2">
        <div className="text-sm text-gray-600">
          Showing page {currentPage} ({filteredRows.length} rows)
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 text-xs rounded-lg ${
              currentPage === 1
                ? "bg-gray-200 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            Previous
          </button>
          {/* <span className="px-3 py-1 text-xs text-gray-700">
                Page {currentPage} of {totalPages}
              </span> */}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || filteredRows.length === 0}
            className={`px-3 py-1 text-xs rounded-lg ${
              currentPage === totalPages || filteredRows.length === 0
                ? "bg-gray-200 cursor-not-allowed text-gray-500"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            Next
          </button>
        </div>
      </div>
      {/* <SalesDashboard /> */}

      {/* Timeline  */}

      <div className="mt-6 w-[50%]">
        <label className="block text-sm font-medium mb-1">Task Timeline</label>
        <div
          className="bg-[#F3F4F6]  rounded border"
          style={{
            height: "160px",
            overflowY: "scroll",
            padding: "6px",
            // marginRight: "10px",
          }}
        >
          {taskTimeLineList ? (
            taskTimeLineList.length > 0 ? (
              taskTimeLineList?.map((item) => {
                return (
                  <div className=" bg-white border rounded shadow p-1 m-2">
                    <p className="flex">
                      <div>
                        <img src={ic_timeline_circle_indicator} />
                      </div>
                      <div className="ms-2  w-full">
                        <div className="flex justify-between items-center">
                          {/* <div> */}
                          <span className="text-xs font-semibold">
                            {format(item.create_date, "dd-MM-yyyy")}{" "}
                          </span>
                          <span
                            className="text-xs font-semibold"
                            style={{ marginLeft: "5px" }}
                          >
                            {format(item.create_date, "hh:mm a")}{" "}
                          </span>
                          <span
                            className="text-xs font-semibold"
                            style={{ marginLeft: "5px" }}
                          >
                            User: {item.userid}
                          </span>
                          {/* </div> */}
                          <div className="px-1">
                            <span className="bg-gray-100 text-gray-400 text-xs font-medium me-2 px-1.5 py-0.5 rounded dark:bg-gray-700 dark:text-white">
                              {" "}
                              {item.status}{" "}
                            </span>
                          </div>
                        </div>
                        {/* <div> */}
                        {/* <span>{item.Comments}</span> */}
                        {/* </div> */}
                      </div>
                    </p>
                  </div>
                );
              })
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img style={{ width: "90px" }} src={ic_no_data} />
                <p className="p-2 text-slate-500"> No data in timeline</p>
              </div>
            )
          ) : (
            <p>Unable to fetch timeline, please contact support team.</p>
          )}
        </div>
      </div>
      {/* SALES OVERVIEW  */}
    </div>
  );
};

export default LogisticTask;
